const state = {
  captcha: [],
  captcha_id: [],
};

export default state;
